import { Grid, GridProps } from '@mui/material';
import { styled } from '@mui/material/styles';

// Define interface for the custom props
export interface AnimatedGridItemProps extends GridProps {
  animationIndex?: number;
}

// Styled component for animations
export const AnimatedGridItem = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'animationIndex',
})<AnimatedGridItemProps>(({ theme, animationIndex = 0 }) => ({
  opacity: 0,
  animation: 'fadeInUp 0.4s ease-out forwards',
  animationDelay: `${animationIndex * 0.05}s`,
  '@keyframes fadeInUp': {
    from: {
      opacity: 0,
      transform: 'translateY(20px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));